import { Injectable } from '@angular/core';
import {
    MatSnackBarConfig,
    // Need these next two, even though they don't *appear* to be used.
    // @See https://github.com/Microsoft/TypeScript/issues/5711#issuecomment-157793294
    // @See https://stackoverflow.com/questions/43900035/ts4023-exported-variable-x-has-or-is-using-name-y-from-external-module-but
    MatSnackBarRef,
    SimpleSnackBar
} from '@angular/material/snack-bar';
import { NotofierTemplatingService } from './notofier-templating.service';

/** The facades for backwards compatibility with old versions of the notification service. */
@Injectable({ providedIn: 'root' })
export class NotofierLegacyService {
    /** @ignore */
    constructor (private _templating: NotofierTemplatingService) {}

    /**
   * @deprecated use `notify()`.
   * A method for displaying a normal snackbar that disappears after 2000ms.
   * @example
   ```
   snackNotificationService.show('My message', { ... })
   ```
   *
   * @param message {string} The message to display in the snackbar.
   * @param customConfig {MatSnackBarConfig} A MatSnackBarConfig object that can be used to override the default snackbar config.
   */
    show (message: string, action?, customConfig?: MatSnackBarConfig): any {
        const preconfig = {
            duration: 2000,
            panelClass: 'ofSnackNotification'
        };

        return this._templating.openMaterialSnackbar({
            message,
            action: action || undefined,
            config: { ...preconfig, ...customConfig }
        });
    }

    /**
	 * @deprecated use `notify()`.
	 * A method for displaying a snackbar that stays on screen until the user can read and dismiss it.
	 * @arg message {string} The error message to display in the snackbar.
	 * @param customConfig {MatSnackBarConfig} A MatSnackBarConfig object that can be used to override the default snackbar config.
	 */

    showError = (message = 'Error! Something went wrong. Please try again.', customConfig: MatSnackBarConfig = {}): any => {
        const preconfig = { panelClass: 'ofErrorSnackNotification' };
        return this._templating.openMaterialSnackbar({
            message,
            action: 'Dismiss',
            config: { ...preconfig, ...customConfig }
        });
    };
}
